import { render, staticRenderFns } from "./resumeMessageStudentside.vue?vue&type=template&id=3837fcc7&scoped=true"
import script from "./resumeMessageStudentside.vue?vue&type=script&lang=js"
export * from "./resumeMessageStudentside.vue?vue&type=script&lang=js"
import style0 from "./resumeMessageStudentside.vue?vue&type=style&index=0&id=3837fcc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837fcc7",
  null
  
)

export default component.exports